module.exports = __webpack_public_path__ + "img/IMG_7479.8adb4299.webp";